const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/PageNoCard.tsx';
import { PageLayout } from '../layout/PageLayout';
import { AppBarMain } from './DashboardPage/AppBar/AppBar';
import * as React from 'react';
import GoBackToDashboardButton from 'App/pages/GoBackToDashboardButton';

export interface IPageProps {
    children: React.ReactNode;
}

export const PageNoCard = (props: IPageProps) => {
    return (
        <PageLayout appBar={<AppBarMain />}>
            <GoBackToDashboardButton />
            <div>{props.children}</div>
        </PageLayout>
    );
};
